// src/components/PrivacyModal.jsx
// Politique de confidentialité (RGPD). Placeholders [RESPONSABLE] et [EMAIL_CONTACT]
// à remplacer avant un lancement public.

import React from "react";

const RESPONSABLE = "[RESPONSABLE — à compléter]";
const EMAIL_CONTACT = "[EMAIL_CONTACT — à compléter]";
const DERNIERE_MAJ = "Mai 2026";

export function PrivacyModal({ onClose }) {
  return (
    <div onClick={onClose} style={overlay}>
      <div onClick={(e) => e.stopPropagation()} style={modal}>
        <div style={header}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#f1f5f9" }}>🔒 Politique de confidentialité</h2>
          <button onClick={onClose} style={closeBtn} aria-label="Fermer">✕</button>
        </div>

        <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 18 }}>Dernière mise à jour : {DERNIERE_MAJ}</div>

        <Section title="1. Responsable du traitement">
          L'application Comparemaison est éditée par {RESPONSABLE}. Pour toute question relative à vos données ou pour exercer vos droits, vous pouvez écrire à : {EMAIL_CONTACT}.
        </Section>

        <Section title="2. Données collectées">
          Comparemaison collecte et traite les données suivantes :
          <List items={[
            "Votre adresse email (pour la création et la connexion à votre compte) ;",
            "Les annonces immobilières que vous enregistrez (prix, surface, adresse, photos, notes, statut, etc.) ;",
            "Vos hypothèses de budget et vos simulations de rendement ;",
            "Les documents que vous téléversez (DPE, diagnostics, plans, photos) ;",
            "Les retours et signalements que vous envoyez via le formulaire de feedback ;",
            "Des données techniques en cas d'erreur applicative (type d'appareil, navigateur, page concernée).",
          ]} />
        </Section>

        <Section title="3. Finalités et base légale">
          Ces données sont traitées pour vous fournir le service (suivi et comparaison de biens immobiliers), sur la base de l'exécution du contrat que vous acceptez en créant un compte. Le formulaire de feedback et la capture d'erreurs servent à améliorer l'application, sur la base de notre intérêt légitime.
        </Section>

        <Section title="4. Analyse par intelligence artificielle">
          Lorsque vous demandez l'analyse d'un document, celui-ci est transmis à notre sous-traitant Anthropic (fournisseur du modèle Claude), situé aux États-Unis, uniquement le temps de l'analyse. Nous vous recommandons de ne pas téléverser de documents contenant des données personnelles de tiers (par exemple le nom du propriétaire vendeur) si elles ne vous sont pas nécessaires.
        </Section>

        <Section title="5. Sous-traitants et hébergement">
          Pour fonctionner, Comparemaison s'appuie sur des prestataires techniques agissant en tant que sous-traitants :
          <List items={[
            "Supabase — base de données, authentification et stockage des fichiers ;",
            "Vercel — hébergement de l'application ;",
            "Anthropic — analyse de documents par IA (États-Unis) ;",
            "Resend — envoi des emails de connexion.",
          ]} />
          Lorsque des données sont transférées hors de l'Union européenne, ces transferts sont encadrés par les garanties appropriées prévues par le RGPD.
        </Section>

        <Section title="6. Durée de conservation">
          Vos données sont conservées tant que votre compte est actif. À la suppression de votre compte, vos annonces, budgets, documents et fichiers associés sont effacés. Les retours de feedback peuvent être conservés de façon anonymisée à des fins d'amélioration du service.
        </Section>

        <Section title="7. Vos droits">
          Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et de portabilité de vos données. Vous pouvez supprimer vous-même votre compte et l'ensemble de vos données depuis l'application (rubrique Compte). Pour toute autre demande, contactez {EMAIL_CONTACT}. Vous avez également le droit d'introduire une réclamation auprès de la CNIL.
        </Section>

        <Section title="8. Sécurité">
          Vos données sont cloisonnées : chaque utilisateur n'a accès qu'à ses propres données, grâce à des règles de sécurité au niveau de la base de données. Les documents sont stockés dans un espace privé et ne sont accessibles que via des liens temporaires signés.
        </Section>

        <div style={{ marginTop: 24, textAlign: "center" }}>
          <button onClick={onClose} style={btnPrimary}>J'ai compris</button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 18 }}>
      <h3 style={{ margin: "0 0 6px", fontSize: 13, fontWeight: 700, color: "#c4b5fd" }}>{title}</h3>
      <div style={{ fontSize: 12.5, color: "#d1d5db", lineHeight: 1.6 }}>{children}</div>
    </div>
  );
}

function List({ items }) {
  return (
    <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>
      {items.map((it, i) => <li key={i} style={{ marginBottom: 4 }}>{it}</li>)}
    </ul>
  );
}

const overlay = {
  position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", zIndex: 2700,
  display: "flex", alignItems: "center", justifyContent: "center", padding: 14,
};
const modal = {
  background: "#0f0f13", color: "#f1f5f9", borderRadius: 18,
  border: "1px solid rgba(255,255,255,0.12)", padding: 24,
  maxWidth: 560, width: "100%", maxHeight: "90vh", overflow: "auto",
};
const header = { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 };
const closeBtn = {
  background: "rgba(0,0,0,0.5)", border: "none", color: "#fff",
  width: 30, height: 30, borderRadius: "50%", fontSize: 14, cursor: "pointer",
};
const btnPrimary = {
  padding: "10px 20px", borderRadius: 9, border: "none",
  background: "#a78bfa", color: "#0f0f13", fontWeight: 700, cursor: "pointer", fontSize: 13,
};
